module.exports = __webpack_public_path__ + "img/lyd.da43f3c5.png";